import { types, async } from '~/utils/typeCreator'

export default types([...async('LOAD_MY_SUBSCRIPTIONS'), 'CLEAR_STATE'], 'HOME')
